function UnitOverview() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Unit.UnitOverview Visual. <br/>
    /// basically just calls the get data from the visual and sets the clocktimer
    /// Uses the load type 3 === UNIT table loading
    /// <br/>
    /// Author: MWI<br />
    /// Date: 13.03.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 20.01.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality copied from the .vb Class                    *<br />
    /// **********************************************************************<br />
    /// </summary>  
}

UnitOverview.prototype = new window.vcTemplate();

UnitOverview.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it adds the clickhandler, the filter and the caleander <br/>
    /// further, it loads the initial content
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        this.userOptions = new window.vcUserOptions();
        me.showInfo("", "", false);
        me.initClickHandler();
        return true;
    } catch (ex) {
        me.writeError("UnitOverview.init", ex);
        return false;
    }
};
UnitOverview.prototype.initClickHandler = function () {
    /// <summary>
    /// Initializes the clickhandler for the UnitOverview Javascript <br/>
    /// 2 ClickHandler are basically present the dropddown handler and the handler for the checkboxes
    /// </summary>
    var me = this;
    try {
        me.visual.find('#ddlUnitDest').unbind('change').change(function () {
            me.showUnit();
        }).trigger("change");
        me.visual.find(".chb").off("click").on("click",
            function() { me.toggleVisibility(this, $(this).is(':checked')); }
        );
    } catch (ex) {
        me.writeError("UnitOverview.initClickHandler", ex);
    }
};


UnitOverview.prototype.showUnit = function () {
    /// <summary>
    /// Loads the Unit tables from the server<br/>
    /// </summary>
    var me = this;
    try {
        me.bluid = me.visual.find('#ddlUnitDest').val();
        me.visual.find('#divOverviewContent').html(me.vcC.getLoadingIcon());
        //me.visual.find('#divOverviewContent').html("test");

        window.VisualCoreService.getData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': 0, 'bluid': me.bluid }),
              function (result) {
                  if (result === null || result === '') {
                      me.showInfo(me.resources.err_loadData, "", true);
                      return;
                  }
                  me.visual.find('#divOverviewContent').html(result);
                  //me.visual.find('.clock').each(function() {
                  //    console.info($(this).html());

                  //});

                  //me.visual.find('.clock').vcClockTimer({ width: 450 });
                  //me.visual.find('.cl').off('click');
                  me.visual.find('.chb').each(function (index, element) { me.toggleVisibility(element, $(element).is(':checked')); });
                  me.toggleActive();
                  me.visual.find('.lstUnit').tipTip({ defaultPosition: 'bottom' }).show();
                  me.visual.find('.clocktimer #clockhelp').each(function () { this.innerHTML = this.innerHTML.replace('| ALT + click = mark time range', ''); });
                  me.visual.find('.fileView').unbind('click').click(function () {
                      window.showModalPopup("<div id='divMediaPopup1' class='frame' ></div>", 700, 394);
                      var media = {
                          mediaid: $(this).attr('data-id'),
                          height: 374,
                          width: 680,
                          pos: 'right',
                          show: true
                      };
                      me.vcVisual.addVisualContentByName('divMedia', 'VISUAL_FILEVIEWER', 'Popup1', window.getCurrentTimestamp(), 374, 680, JSON.stringify(media), '', 2);
                  });
                  me.userOptions.getUserOptions({ 'optgroupid': 'unitoverview' }, function (result) {
                      if (result === null) {return true; }
                      if (result.rows === null) { me.showInfo(me.resources.err_loadData, "", true); }
                      for (var i = 0; i < result.rows.length; i++) {
                          me.visual.find('.useroption[data-optid=' + result.rows[i].optid + ']').prop('checked', result.rows[i].bval);
                      }

                      return true;
                  });
              });

    } catch (ex) {
        me.writeError("UnitOverview.showUnit", ex);
    }

};


UnitOverview.prototype.toggleVisibility = function (obj, checked) {
    /// <summary>
    /// Handles the visibility of the various tables and details
    /// </summary>
    var me = this;
    try {
        me.userOptions.setUserOptions({
            'optgroupid': 'unitoverview',
            'optid': parseInt($(obj).attr('data-optid'), 10),
            'bval': checked},function () { });
        switch (obj.id) {
            case 'chkUnit':
                me.visual.find('.tu').toggle(checked);
                break;
            case 'chkHW':
                me.visual.find('.thw').toggle(checked);
                checked
                    ? me.visual.find('.tsd, .ta, .tal').removeClass('nothw')
                    : me.visual.find('.tsd, .ta, .tal').addClass('nothw');
                break;
            case 'chkAL':
                me.visual.find('.ta').toggle(checked);
                break;
            case 'chkDS':
                me.visual.find('.tsd').toggle(checked);

                checked ? me.visual.find('.tal').removeClass('notsd') : me.visual.find('.tal').addClass('notsd');
                break;
            case 'chkAlarm':
                me.visual.find('.tal.usal').toggle(checked);
                break;
            case 'chkSysAlarm':
                me.visual.find('.tal.sysal').toggle(checked);
                break;
            case 'chkTecDet':
                me.visual.find('.tecDet').toggle(checked);
                me.visual.find('.tecDet.ci').show();
                break;
        }
        if (me.visual.find('#h3sig ~ table:visible').length < 1) {
            me.visual.find('#h3sig').hide();
        } else {
            me.visual.find('#h3sig').show();
        }
        if (me.visual.find('#h3hw ~ table:visible').not('#h3sig ~ table:visible').length < 1) {
            me.visual.find('#h3hw').hide();
        } else {
            me.visual.find('#h3hw').show();
        }
        if (me.visual.find("#h3all ~ table:visible").length < 1) {
            me.visual.find("#h3all").hide();
        } else {
            me.visual.find("#h3all").show();
        }
    } catch (ex) {
        me.writeError("UnitOverview.toggleVisibility", ex);
    }
};

UnitOverview.prototype.toggleActive = function () {
    /// <summary>
    /// Handles the visibility of the headings
    /// </summary>
    var me = this;
    try {
     
        if (me.visual.find('.thw').length < 1) {
            me.visual.find('#h3hw').hide();
            me.visual.find('#chkHW').hide();
            me.visual.find('label[for=chkHW]').hide();
            me.visual.find('.tsd, .ta, .tal').addClass('nothw');
        }


    } catch (ex) {
        me.writeError("UnitOverview.toggleActive", ex);
    }
};